import { fetcher } from '@commenda/utils';
import { TPrerequisiteStatus } from './types';

type GetPrerequisitesResult =
  | { ok: true; data: TPrerequisiteStatus[] }
  | { ok: false; error: string };

const getPrerequisites = async (
  recordId: string
): Promise<GetPrerequisitesResult> => {
  const res = await fetcher(`tp-document-record/${recordId}/prerequisites`, {
    method: 'GET',
  });

  if (!res.ok) {
    return { ok: false, error: 'Failed to fetch prerequisites' };
  }

  const data = (await res.json()) as TPrerequisiteStatus[];
  return { ok: true, data };
};

export { getPrerequisites };
export type { GetPrerequisitesResult };
